import type { ButtonHTMLAttributes } from "react";

const iconActionButtonClassName =
  "inline-flex box-content items-center justify-center rounded-[10px] h-5 w-5 p-2 cursor-pointer focus-visible:outline focus-visible:outline-[revert] hover:bg-[rgba(210,213,219,1)] focus:bg-[rgba(210,213,219,1)]";

export const iconActionButtonClasses = iconActionButtonClassName;

export const IconActionButton = ({
  className,
  type = "button",
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) => (
  <button
    type={type}
    className={`${iconActionButtonClassName} ${className ?? ""}`}
    {...props}
  />
);
